import { render } from "./UitvaartverzekeringView.vue?vue&type=template&id=a4ee7634"
import script from "./UitvaartverzekeringView.vue?vue&type=script&lang=js"
export * from "./UitvaartverzekeringView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__